import clsx from 'clsx'

import css from './scss/PointsLine.module.scss'
import { PointsLineProps } from './ts'

function PointsLine({ line }: PointsLineProps) {
  const lastIndex = line.length - 1
  return (
    <div>
      {line.map(({ title, description }, index) => (
        <div
          key={index}
          className={clsx(
            'relative ml-8 pl-16 pt-2 sm:pt-4 border-l-8 border-gray-15',
            {
              'pb-20 sm:pb-32': index !== lastIndex,
              'border-opacity-0': index === lastIndex,
            }
          )}
        >
          <div className={css['circle-ring']} />
          <div className={css.circle}>{index + 1}</div>
          <h4 className="font-semibold sm:text-xl">{title}</h4>
          <p className="mt-2 text-sm text-gray-100 sm:text-base max-w-260px">
            {description}
          </p>
        </div>
      ))}
    </div>
  )
}

export default PointsLine
